// breaking circular dependency
let store: any;

export function initializeStoreUtil(storeInstance: any) {
  store = storeInstance;
}

export function getCurrentIdToken() {
  return store.getState().auth?.idToken as string | undefined;
}
